// Сервис кеширования для API запросов
class CacheService {
  constructor() {
    this.cache = new Map();
    this.defaultTTL = 60 * 60 * 1000; // 60 минут (увеличено с 30)
    this.shortTTL = 5 * 60 * 1000;    // 5 минут для часто меняющихся данных
    this.longTTL = 24 * 60 * 60 * 1000; // 24 часа для редко меняющихся данных
  }

  getCacheKey(key, params = {}) {
    return `${key}|${JSON.stringify(params)}`;
  }

  get(key, ttl = this.defaultTTL) {
    const cached = this.cache.get(key);
    if (cached && Date.now() - cached.timestamp < ttl) {
      return cached.data;
    }
    if (cached) {
      this.cache.delete(key);
    }
    return null;
  }

  set(key, data) {
    this.cache.set(key, {
      data: JSON.parse(JSON.stringify(data)), // Глубокое копирование
      timestamp: Date.now()
    });
  }

  // Проверка, устарели ли данные
  isStale(key, ttl = this.defaultTTL) {
    const cached = this.cache.get(key);
    if (!cached) return true;
    return Date.now() - cached.timestamp >= ttl;
  }

  invalidate(pattern) {
    const keysToDelete = [];
    for (const key of this.cache.keys()) {
      if (key.includes(pattern)) {
        keysToDelete.push(key);
      }
    }
    keysToDelete.forEach(key => this.cache.delete(key));
    if (keysToDelete.length > 0) {
      console.log(`Инвалидировано ${keysToDelete.length} записей кеша по паттерну "${pattern}"`);
    }
  }

  clear() {
    this.cache.clear();
    console.log('Кеш полностью очищен');
  }

  getSize() {
    return this.cache.size;
  }

  getStats() {
    return {
      size: this.cache.size,
      keys: Array.from(this.cache.keys())
    };
  }
}

export const cacheService = new CacheService();